import React, { useEffect, useState } from 'react';
import { useLocation } from '@reach/router';

import { useAgilyticsDispatch } from '@agilytics/global-state';
import atlassian from '@agilytics/utils/atlassian';

export default function JiraCallback({ navigate }) {
  const dispatch = useAgilyticsDispatch();
  const location = useLocation();
  const [requestSent, setRequestSent] = useState(false);

  useEffect(() => {
    const getAccessToken = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const token = await atlassian.getTokensWithCode(code);
      if (token) {
        dispatch({ type: 'updateAccessToken', accessToken: token });
      }
      navigate(`/select-instance`, { replace: true });
    };
    if (!requestSent) {
      getAccessToken();
      setRequestSent(true);
    }
  }, [location.search, navigate, dispatch, requestSent]);

  return <div>Loading..</div>;
}
